export enum WizardStepsEnum {
    LANGUAGE_STYLE = 'LANGUAGE_STYLE',
    PRESENTATION_MODE = 'PRESENTATION_MODE',
    INDICATIONS = 'INDICATIONS',
    USE_CASES = 'USE_CASES',
    FINISHED = 'FINISHED'
}
